import React from 'react';
import styled from 'styled-components';
import { _ } from '_locales';
import images from '_images';

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  position: absolute;
  z-index: 1;
  top: 25%;
  left: ${({ isOnBoarding }) => (isOnBoarding === 'firstOnBoarding' ? '10%' : 'auto')};
  right: ${({ isOnBoarding }) => (isOnBoarding === 'secondOnBoarding' ? '10%' : 'auto')};
  width: ${({ windowsWidth }) => (windowsWidth >= 500 ? '45%' : '85%')};
`;

const OnBoardingText = styled.p`
  color: white;
  left: 50%;
  transform: ${({ isOnBoarding }) => (isOnBoarding === 'firstOnBoarding' ? 'translate(-5%, 0%)' : 'translate(5%, 0%)')};
  text-align: center;
  font-size: 2.1vh;
  line-height: 1.5em;
`;

const Hand = styled.img`
  left: 50%;
  transform: ${({ isOnBoarding }) => (isOnBoarding === 'firstOnBoarding' ? 'translate(-20%, 0%)' : 'translate(20%, 0%)')};
`;

/**
 * This component shows on boarding screens for
 * two senarios of first or second on boarding screen
 *
 */

const OnBoarding = ({ isOnBoarding }) => (
  <Container isOnBoarding={isOnBoarding}>
    <Hand
      src={images.recycleRight.on_boarding}
      isOnBoarding={isOnBoarding}
    />
    {(isOnBoarding === 'firstOnBoarding')
      && (
        <>
          <OnBoardingText isOnBoarding={isOnBoarding}>{_('recycleRight.please_swipe_right')}</OnBoardingText>
          <img
            src={images.recycleRight.on_boarding_arrow}
            alt="please swipe right"
          />
        </>
      )}
    {(isOnBoarding === 'secondOnBoarding')
      && (
        <>
          <OnBoardingText>{_('recycleRight.please_swipe_left')}</OnBoardingText>
          <img
            src={images.recycleRight.arrow_left}
            alt="please swipe left"
          />
        </>
      )}
  </Container>
);

export default OnBoarding;
